<template>
  <div
    :class="{
      [id + '-search-list']: true,
      'single-select': isSingle,
      'single-select': isRadio,
      'multiple-select': isMultiple,
      'with-headers': headers && headers.length > 0,
    }"
  >
    <div v-if="isSearchable" class="item-search">
      <InputField
        :value="searchString"
        :placeholder="$t(placeholder)"
        :config="{
          borderStyle: 'around',
          maxWidth: '200px',
          minWidth: '200px',
          width: '200px',
        }"
        @keyup="onSearchInputkeyup"
      ></InputField>
    </div>
    <div class="items-container">
      <div
        v-if="isMultiple && showSelectAll && checkBoxPosition == 'top'"
        class="select-all-row"
      >
        <div class="select-all-checkbox">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              @click.stop="onSelectAll"
              :name="'select_all'"
              :id="'select_all'"
              :checked="selectedAll"
            />
            <div class="checkmark"></div>
          </div>
        </div>
        <div class="select-all-text" @click="onSelectAllRow">
          {{ $t("select_all") }}
        </div>
      </div>
      <div
        v-if="
          (itemsMultipleMargin &&
            ((isSearchable &&
              !isMultiple &&
              !(headers && headers.length > 0)) ||
              (isMultiple && !isSearchable && !showSelectAll))) ||
          (isMultiple && !showSelectAll)
        "
        class="items-multiple-margin"
        :style="{
          height: '20px',
          width: '1px',
        }"
      ></div>
      <table v-if="!multiColumn" class="dt-table2 search-list" style="position: relative">
        <thead v-if="headers && headers.length > 0" class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
              'margin-right': hRowMarginRight,
            }"
          >
            <th
              style="border-bottom: none"
              v-for="header of headers"
              :key="header[keyProperty]"
              class="dt-table2--column"
            >
              {{ $t(header.text) }}
            </th>
          </tr>
        </thead>
        <tbody
          class="dt-table2--body"
          ref="tbody"
          @scroll="onTBBodyScroll"
          :style="{
            filter: loading ? `opacity(0.33)` : ``,
          }"
        >
          <template v-for="item of items">
            <slot name="item" v-bind:item="item">
              <tr
                class="dt-table2--row"
                :class="{
                  'new-item-row': isNewItemRow(item),
                  disabled: disabledFunc(item),
                  selected: selecteditems.has(item[keyProperty]),
                }"
                :key="item[keyProperty]"
                @click="(e) => onClickRow(e, item)"
              >
                <td v-if="isMultiple" class="dt-table2--column checkbox-column">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      @click.stop="(e) => onCheckboxChange(e, item)"
                      :name="item[keyProperty]"
                      :id="item[keyProperty]"
                      :checked="selecteditems.has(item[keyProperty])"
                      :disabled="disabledFunc(item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </td>
                <td v-if="isRadio" class="dt-table2--column checkbox-column">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      @click.stop="(e) => onSingleCheckboxChange(e, item)"
                      :name="item[keyProperty]"
                      :id="item[keyProperty]"
                      :checked="selecteditems.has(item[keyProperty])"
                      :disabled="disabledFunc(item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </td>
                <td class="dt-table2--column" v-if="!isNewItemRow(item)">
                  <span class="txtov">
                    {{ item[label] }}
                  </span>
                </td>
                <td
                  @click.stop
                  class="dt-table2--column"
                  v-if="isNewItemRow(item)"
                >
                  <InputField
                    :value="item[label]"
                    :placeholder="'Insert a ' + $dft.snakeCaseToWords(label)"
                    :config="{
                      borderStyle: 'none',
                      noicon: true,
                    }"
                    :disabled="newInputDisabled"
                    :id="'new-item-input'"
                    @blur="(e) => blurSubject$.next(true)"
                    @keyup="(e) => onNewInputKeyup(e, item)"
                  ></InputField>
                </td>
                <td @click.stop v-if="isNewItemRow(item)">
                  <div class="dt-icon-container">
                    <img
                      @click="cancelNewItem"
                      src="static/icons/delete.svg"
                      class="dt-icon v5 s1"
                    />
                  </div>
                </td>
                <div v-if="isNewItemRow(item)" class="top-border"></div>
                <div v-if="isNewItemRow(item)" class="bottom-border"></div>
              </tr>
            </slot>
          </template>
        </tbody>
        <div
          v-if="loading"
          :style="{
            position: 'absolute',
            color: 'var(--text-secondary)',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }"
        >
          {{ loadingText }}
        </div>
      </table>

      <div v-if="multiColumn" class="dt-table2 contact-table">
    
    <div style="display: block;column-count: 4;
        column-gap: 20px;" class="dt-table2--body">
      <div
        class="dt-table2--row"
        v-for="item in items"
        :key="item[keyProperty]"
        @click="(e) => onClickRow(e, item)"
      >
        <div
          style="max-width: 35px"
          class="dt-table2--column checkbox-column"
        >
          <div class="dt-checkbox v2 s1">
            <input
                      type="checkbox"
                      @click.stop="(e) => onCheckboxChange(e, item)"
                      :name="item[keyProperty]"
                      :id="item[keyProperty]"
                      :checked="selecteditems.has(item[keyProperty])"
                      :disabled="disabledFunc(item)"
                    />
            <div class="checkmark"></div>
          </div>
        </div>
        <div class="dt-table2--column">
          {{ item[label] }}
        </div>
       
      </div>
    </div>
     </div>

      <div
        v-if="isMultiple && showSelectAll && checkBoxPosition == 'bottom'"
        class="select-all-row"
      >
        <div class="select-all-checkbox">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              @click.stop="onSelectAll"
              :name="'select_all'"
              :id="'select_all'"
              :checked="selectedAll"
            />
            <div class="checkmark"></div>
          </div>
        </div>
        <div class="select-all-text" @click="onSelectAllRow">Select All</div>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from "../../plugins/text-field/input-field";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { addRemoveSet, subscribeSubject } from "../../utility";
import { TableScroller } from "@plugins/datatable/table-scroller";
import { Subject } from "rxjs";

export default {
  components: {
    InputField,
  },
  props: {
    checkBoxPosition: {
      default: "top",
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: [],
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Set,
      default: () => new Set(),
    },
    keyProperty: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "search",
    },
    label: {
      type: String,
      required: true,
    },
    isSearchable: {
      default: true,
    },
    selectionNumber: {
      type: String,
      default: "multiple",
    },
    disabledFunc: {
      type: Function,
      default: () => false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "Loading...",
    },
    itemsMultipleMargin: {
      type: Boolean,
      default: true,
    },
    showSelectAll: {
      type: Boolean,
      default: true,
    },
    showSelected: {
      type: Boolean,
      default: true,
    },
    multiColumn:{
      type: Boolean,
      default: false,
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler: function (to, from) {
        //console.log('Search List Selected', to);
        if (to) {
          this.selecteditems = to;
          // console.log('Setting SelectedItem', this.selecteditems);
        }
      },
    },
    items: {
      immediate: true,
      handler: function (newVal, oldVal) {
        // console.log('Resetting Data');
        this.resetData();
      },
    },
  },
  data: function () {
    return {
      scrollSubject: new Subject(),
      searchString: "",
      selecteditems: new Set(),
      searchSubject$: new Subject(),
      blurSubject$: new Subject(),
      newInputDisabled: false,
    };
  },
  mounted: function () {
    subscribeSubject(this, this.scrollSubject, (scrollTop) => {
      const scroller = TableScroller.createScroller(this.$refs["tbody"]);
      console.log("WERT", scrollTop, scroller, TableScroller);
      if (scroller.scrollTop > 0 && scroller.scrollPercent > 90) {
        this.$emit("scrollNext", scroller.scrollPercent);
      }
    });
    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(distinctUntilChanged(), debounceTime(500)),
      (searchString) => {
        this.emitSearch();
      }
    );
    this.$subscribeTo(
      this.blurSubject$.asObservable().pipe(debounceTime(200)),
      (blurFlag) => {
        // console.log(blurFlag);
        if (blurFlag) {
          this.blurNext();
        }
      }
    );
  },
  computed: {
    hRowMarginRight: function () {
      if (this.items.length > 380 / 28) {
        // return "28px";
      }
    },
    selectedAll: function () {
      return (
        this.items.length !== 0 && this.selecteditems.size === this.items.length
      );
    },
    isMultiple: function () {
      return this.selectionNumber === "multiple";
    },
    isSingle: function () {
      return this.selectionNumber === "single";
    },
    isRadio: function () {
      return this.selectionNumber === "radio";
    },
  },
  methods: {
    onTBBodyScroll: function (event) {
      // console.log('onTBBodyScroll', event.target.scrollTop);

      this.scrollSubject.next(event.target.scrollTop);
    },
    onScrollerScroll: function (event) {
      this.setScrollTop(event.target.scrollTop);
    },
    setScrollTop: function (value) {
      this.bodyScrollTop = value;
      this.$refs["tbody"].scrollTop = this.bodyScrollTop;

      const { height, scrollHeight, scrollTop, scrollPercent } =
        getScrollDimensionY(this.$refs["tbody"]);

      if (scrollTop > 0 && scrollPercent > this.config.scrollNextThreshold) {
        this.$emit("scrollnext", scrollPercent);
      }
    },
    resetData: function () {
      this.selectedItems = this.selected || new Set();
      //console.log("Log: ResetData selectedItems", this.selectedItems);
      this.emitSelected();
    },
    updateSet: function (operation = true, set = new Set(), selected) {
      if (this.isMultiple) {
        if (selected) {
          return addRemoveSet(operation, set, selected);
        } else {
          return set;
        }
      }
      if (this.isSingle) {
        // console.log('This is Sing;e', new Set([selected]));
        if (selected) {
          return new Set([selected]);
        } else {
          return new Set();
        }
      }
      if (this.isRadio) {
        // console.log('This is Sing;e', new Set([selected]));
        if (selected) {
          return new Set([selected]);
        } else {
          return new Set();
        }
      }

      return addRemoveSet(operation, set, selected);
    },
    onSingleCheckboxChange: function (event, item) {
      if (this.disabledFunc(item)) {
        return;
      }

      this.selecteditems = this.updateSet(
        event.target.checked,
        [],
        item[this.keyProperty]
      );
      this.emitSelected();
    },
    onCheckboxChange: function (event, item) {
      console.log({event,item})
      if (this.disabledFunc(item)) {
        return;
      }

      this.selecteditems = this.updateSet(
        event.target.checked,
        this.selecteditems,
        item[this.keyProperty]
      );
      this.emitSelected();
    },
    onClickRow: function (event, item) {
      // console.log('onClickRow', this.selectedItems, item);
      if (this.disabledFunc(item)) {
        return;
      }

      this.selecteditems = this.updateSet(
        "toggle",
        this.selecteditems,
        item[this.keyProperty]
      );
      this.emitSelected();
    },
    onSearchInputkeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(this.searchString);
    },
    emitSelected: function () {
      //console.log("Log: emitSelected this.selecteditems", this.selected, this.selecteditems);
      this.$emit("selected", this.selecteditems);
    },
    emitSearch: function () {
      this.$emit("searched", this.searchString);
    },
    onSelectAll: function (event) {
      const checked = event.target.checked;
      console.log({ onSelectAll: checked });
      this.checkOrUncheckAll(checked);
    },
    onSelectAllRow: function () {
      const checked = this.selectedAll;
      console.log({ onSelectAllRow: checked });
      this.checkOrUncheckAll(!checked);
    },
    checkOrUncheckAll(checked) {
      if (checked) {
        this.selecteditems = new Set(
          this.items
            .map((i) => {
              console.log("isDisabled", pk, this.disabledFunc(i));
              const pk = i[this.keyProperty];
              if (this.disabledFunc(i)) {
                return this.selecteditems.has(pk) ? pk : null;
              } else {
                return pk;
              }
            })
            .filter((e) => e)
        );
      } else {
        this.selecteditems = new Set(
          this.items
            .map((i) => {
              const pk = i[this.keyProperty];
              console.log("isDisabled", pk);
              if (this.disabledFunc(i)) {
                return this.selecteditems.has(pk) ? pk : null;
              } else {
                return null;
              }
            })
            .filter((e) => e)
        );
      }
      this.emitSelected();
    },
    focusNewInput: function () {
      this.newInputDisabled = false;
      const element = document.querySelector("input#new-item-input");
      if (element) {
        element.focus();
      }
    },
    isNewItemRow: function (item) {
      return item[this.keyProperty] == "NEW_ITEM_TEMP";
    },
    cancelNewItem: function () {
      this.blurSubject$.next(false);
      this.$emit("cancelNewItem", true);
    },
    blurNext: function () {
      this.submitNewInput();
    },
    submitNewInput: function () {
      this.newInputDisabled = true;
      const value = this.items.find(this.isNewItemRow)[this.label];

      // console.log('SUbmit', value);
      if (!value) {
        this.cancelNewItem();
      } else {
        this.$emit("newAdded", value);
      }
    },
    onNewInputKeyup: function (event, item) {
      item[this.label] = event.target.value;

      // console.log(event);
      if (event.key === "Enter") {
        this.blurSubject$.next(true);
      }
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.with-headers {
  .dt-table2 {
    --row-margin-header: 0px;
    --row-margin: 0px;
    .dt-table2--head {
    }
    .dt-table2--column {
      padding: 0px 8px;
      border-right: 1px solid var(--sprt-7);
    }

    .dt-table2--head {
      .dt-table2--column {
        border-right: 1px solid transparent;
      }
    }
    .dt-table2--column:nth-child(1) {
      margin-left: 0px;
    }
    .dt-table2--column:last-child {
      margin-right: 0px;
    }
  }
}

.single-select {
  .dt-table2 {
    margin-top: 20px;
  }
}
th.dt-table2--column {
  text-align: left;
  color: #828282;
  font-weight: 400;
}
.layout {
}
.item-search {
  // margin-bottom: 20px;
}
.items-container {
  // height: 360px;
  overflow: auto;
  .select-all-row {
    display: flex;
    margin: 0px 5px;
    padding: 10px 5px;
    padding-left: 0px;
    color: var(--text-secondary);
    cursor: pointer;
    .select-all-checkbox {
      flex: 0.05;
      padding-right: 10px;
      padding-left: 6px;
      padding-top: 3px;
    }
    .select-all-text {
      flex: 1;
      height: 100%;

      &:hover {
        color: var(--text-primary);
      }
    }
  }
}

.new-item-row {
  background: white;

  &:hover {
    --row-hover-background: white;
  }

  position: relative;
  .top-border,
  .bottom-border {
    width: 100%;
    background: var(--sprt-7);
    height: 2px;
    position: absolute;
    left: 0px;
  }

  .top-border {
    top: -1px;
  }
  .bottom-border {
    bottom: 0px;
  }
}
</style>


